










import { Component, Prop, Vue, Watch } from "vue-property-decorator";

@Component
export default class TranslationsCompletion extends Vue
{
	@Prop() completion!: number;

	data()
	{
		return {
			model: {
				completion: this.completion
			}
		};
	}

	flooredCompletion(n: number)
	{
		return Math.floor(n);
	}
}
